import styled from '@emotion/styled';

export const BetDelayRow = styled('div', { label: 'BetDelayRow' })`
    margin-left: -2.5px;
    margin-right: -2.5px;
    display: flex;
    justify-content: end;
`;
